<div class="banner" role="banner">
  <h1>{{ 'ticket.transfer.page.title' | translate }}</h1>
</div>

<div class="container mt-4">
  <div class="mb-4">
    <fgbcl-contact-management-widget></fgbcl-contact-management-widget>
  </div>
  <fgbcl-games-with-tickets-list></fgbcl-games-with-tickets-list>
</div>
